import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from "react";
import Styled from "styled-components"; // Colors

import { extended, primary } from "@uprise/colors";
var Paragraph = Styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      font-style: normal;\n      font-stretch: normal;\n      line-height: ", ";\n      letter-spacing: normal;\n      display: ", ";\n      width: ", ";\n      text-align: ", ";\n\tcolor: ", ";\n\t\n\t@media (max-width: 1024px) {\n\t\twidth: ", ";\n\t}\n"])), function (props) {
  return props.weight === "bold" ? "Proxima Nova Semibold" : "Proxima Nova";
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.weight;
}, function (props) {
  return props.lineHeight ? props.lineHeight : "1.56";
}, function (props) {
  return props.inline ? "inline" : "block";
}, function (props) {
  return props.width;
}, function (props) {
  return props.textAlign;
}, function (props) {
  return props.color;
}, function (props) {
  return props.smallWidth;
});
export var P = function P(_ref) {
  var myRef = _ref.myRef,
      children = _ref.children,
      inline = _ref.inline,
      fontSize = _ref.fontSize,
      className = _ref.className,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      width = _ref.width,
      smallWidth = _ref.smallWidth,
      lineHeight = _ref.lineHeight,
      textAlign = _ref.textAlign,
      weight = _ref.weight,
      color = _ref.color;
  return /*#__PURE__*/React.createElement(Paragraph, {
    ref: myRef,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: className,
    fontSize: fontSize,
    width: width,
    inline: inline,
    lineHeight: lineHeight,
    weight: weight,
    smallWidth: smallWidth,
    textAlign: textAlign,
    color: color
  }, children);
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

P.defaultProps = {
  fontSize: "18px",
  weight: "normal",
  color: extended.charcoal.one,
  width: "",
  textAlign: ""
};